import React from 'react'

export default function Submitted({ status = 'default' }) {
  let text = 'SUBMITTED';

  if (status === 'unpaid') {
    text = 'SUBMITTED';
  } else if (status === 'verify') {
    text = 'SUBMITTED & VERIFIED';
  } else if (status === 'collected') {
    text = 'SUBMITTED & COLLECTED';
  }

  return (
    <div>
      <div className="row-bot mt-3" style={{ display: 'block' }}>
        <div className="text-border">{text}</div>
      </div>
    </div>
  )
}
